import { DataTableColumn } from '@shared/ui/data-table';

export const getCellLeftPosition = <T extends object>(columns: DataTableColumn<T>[], column: DataTableColumn<T>) => {
  if (!column.fixed) return 0;

  const columnIndex = columns.findIndex(({ field }) => field === column.field);

  let left = 0;

  for (let i = 0; i < columnIndex; i++) {
    left += columns[i].width || 0;
  }

  return left;
};
